var react;
var dom;

/*if (process.env.NODE_ENV == 'production'){
    react = require('react/dist/react.min.js').default;
    dom   = require('react-dom/dist/react-dom.min.js');
} else {*/
    react = require('react');
    dom   = require('react-dom');
// }

export default react;

export {
    react,
    dom
};



// WEBPACK FOOTER //
// ./src/helpers/react.js